export const CLOSE_BUTTON_TEXT = `Закрыть`;
export const MODAL_HEADING_TEXT = `Поделиться корзиной`;
export const MODAL_DESCRIPTION = `Просто отправьте ссылку, и получатель сможет открыть список товаров из  вашей текущей корзины.`;
export const LINK_TEXT = `Ссылка на корзину`;
export const BUTTON_TEXT = `Скопировать ссылку`;
